import { Label, Cloud, Settings, Replay } from '@mui/icons-material';
import {
  useTypedParams,
  application_settings_tags_path,
  application_settings_environment_list_path,
  application_settings_deployment_integrations_list_path,
  application_settings_deployment_and_rollback_path,
} from 'app-zephyr-routes';
import { useCheckDevopsFeature } from 'ze-sdk';
import { NavigationGroups, LeftSideNavigationMenu } from 'app-zephyr-components/LeftSideNavigationMenuV2';

export const sideNavItems = ({
  orgName,
  projName,
  appName,
}: {
  orgName: string;
  projName: string;
  appName: string;
  isDevopsAllowed?: boolean;
}): NavigationGroups => [
  // todo: @sveta should be used when devops functionality will be available on prod
  // {
  //   id: 'release-pipelines',
  //   title: 'Release Pipelines',
  //   url: application_release_pipeline_path({
  //     organization: {
  //       name: orgName,
  //     },
  //     project: {
  //       name: projName,
  //     },
  //     application: {
  //       name: appName,
  //     },
  //   }),
  //   icon: <SyncAlt sx={{ width: 18, height: 18 }} />,
  //   disabled: !isDevopsAllowed,
  // },
  {
    id: 'tags',
    title: 'Tags',
    url: application_settings_tags_path({
      organization: {
        name: orgName,
      },
      project: {
        name: projName,
      },
      application: {
        name: appName,
      },
    }),
    icon: <Label sx={{ width: 18, height: 18 }} />,
  },
  {
    id: 'environments',
    title: 'Environments',
    url: application_settings_environment_list_path({
      organization: {
        name: orgName,
      },
      project: {
        name: projName,
      },
      application: {
        name: appName,
      },
    }),
    icon: <Cloud sx={{ width: 18, height: 18 }} />,
  },
  {
    id: 'deployment-integrations',
    title: 'Deployment Integrations',
    url: application_settings_deployment_integrations_list_path({
      organization: {
        name: orgName,
      },
      project: {
        name: projName,
      },
      application: {
        name: appName,
      },
    }),
    icon: <Settings sx={{ width: 18, height: 18 }} />,
  },
  {
    id: 'deployment-rollback',
    title: 'Deployment & Rollback',
    url: application_settings_deployment_and_rollback_path({
      organization: {
        name: orgName,
      },
      project: {
        name: projName,
      },
      application: {
        name: appName,
      },
    }),
    icon: <Replay sx={{ width: 18, height: 18 }} />,
  },
];

export const ApplicationDevOpsMenuLayout = () => {
  const { organization, project, application } = useTypedParams();
  const { data: isDevopsAllowed } = useCheckDevopsFeature();

  if (!organization || !project || !application) throw new Error('Missing required path parameters');

  return (
    <LeftSideNavigationMenu
      items={sideNavItems({
        orgName: organization,
        projName: project,
        appName: application,
        isDevopsAllowed: isDevopsAllowed?.data,
      })}
    />
  );
};
